
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";




import ReportingApi from "@/services/reporting-api";
import PartnerChanelChart from "@/components/partnerChanelChart";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { PartnerChanelChart,Layout},

    mounted(){

      this.selectedType = this.typesOptions[0]

      this.getCurrentMonthAndYear()
      this.getPartnerStatsByMonth()
      this.getPartnerStats()
      var date = new Date();
      
      this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      //this.firstDay = new Date();
      const startoffset = this.firstDay.getTimezoneOffset()
      this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
      this.firstDay=this.firstDay.toISOString().split('T')[0]

      this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      //this.lastDay = new Date()
      const endoffset = this.lastDay.getTimezoneOffset()
      this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
      this.lastDay=this.lastDay.toISOString().split('T')[0]

  },

  computed: {
    role() {
      return this.$cookies.get('userr');
    },
    isPartnerQuantityBeingOrderedEnabled(){
      return  process.env.VUE_APP_FEATURES_SHOW_PARTNER_QUANTITY_BEING_ORDERED === 'true'
    },


    isPartnerStatsExportEnabled(){
      return  process.env.VUE_APP_FEATURE_EXPORT_PARTNER_STATS === 'true'
    },

    // `partnerStats || []` dans le template fabriquait un tableau neuf a chaque
    // rendu, ce qui reveille le watcher `items` de b-table pour rien.
    partnerStatsItems(){
      return this.partnerStats || []
    },

    // Meme forme que la computed du meme nom dans components/claim-reporting.vue :
    // une expression inline dans le template renverrait un tableau neuf a chaque
    // rendu.
    yearOptions(){
      if (!this.currentYear) {
        return []
      }

      const years = []
      for (let y = 2020; y <= this.currentYear; y++) {
        years.push(y)
      }
      return years
    },
    

     partnerItemFields() {
      const fields = [
        { key: "itemCode", label: "Réference" },
        { key: "itemTitle", label: "Article", sortable: false, tdClass: "text-left align-middle", thStyle: "minWidth:250px;" },
        { key: "stock", label: "qté° Stock", sortable: false, tdClass: "text-center font-weight-bold align-middle", thStyle: "minWidth:100px;" },

                ...(this.isPartnerQuantityBeingOrderedEnabled
          ? [{
              key: "qteBc",
              label: "Cmde en cours",
              sortable: false,
              tdClass: "text-center align-middle",
              thStyle: "minWidth:55px;"
            }]
          : []),

        { key: "january", label: "Janvier", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "february", label: "Février", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "march", label: "Mars", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "april", label: "Avril", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "may", label: "Mai", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "june", label: "Juin", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "july", label: "Juillet", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "august", label: "Août", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "september", label: "Septembre", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "october", label: "Octobre", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "november", label: "Novembre", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" },
        { key: "december", label: "Décembre", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "minWidth:55px;" }
      ];

      return fields;
    }
  },

  watch:{
        selectedType : function (){
            this.refresh();
        },
        year : function (){
            this.refresh();
        }
    },

  data() {
    return {
      currentYear:null,
      currentMonth:null,

      year:null,

      isAdmin:false,
      hasReportingAccess:false,
      hasCustomersHistoryAcess:false,
      hasSynchronisationAccess:false,
      firstDay:null,
      lastDay:null,
      turnoverByWeekList:null,
      turnoverByMonthList:null,
      turnoverByWeekListPharma:null,
      turnoverByMonthListPharma:null,
      partnerStats:null,
      partnerStatsByMonth:null ,
      isPartnerStatsLoading:false,
      isPartnerStatsByMonthLoading:false,

      selectedType : null,
      typesOptions : [{value:'PARA', text:"Articles Para-Pharmaceutiques"}, {value:'PHARMA', text:"Articles Pharmaceutiques"}],



    };
  },


  methods: {

    exportPDF(){
      ReportingApi.exportPartnerStatsPdf(this.selectedType ? this.selectedType.value : this.typesOptions[0].value, this.year);
    },
    exportXLS(){
        ReportingApi.exportPartnerStatsXls(this.selectedType ? this.selectedType.value : this.typesOptions[0].value, this.year);
    },

    getPartnerStatsByMonth(){

      if (!this.selectedType) {
        this.selectedType = this.typesOptions[0];
      }

      this.partnerStatsByMonth = null;
      this.isPartnerStatsByMonthLoading = true;

      ReportingApi.getPartnerStatsByMonth(this.selectedType ? this.selectedType.value : this.typesOptions[0].value , this.year).then(
          response => {
            this.partnerStatsByMonth=response;     
          
          } 
      ).finally(() => {
            this.isPartnerStatsByMonthLoading = false;
      })
    },
 
    getPartnerStats(){

      if (!this.selectedType) {
        this.selectedType = this.typesOptions[0];
      }

      this.partnerStats = null;
      this.isPartnerStatsLoading = true;

      ReportingApi.getPartnerStats(this.selectedType ? this.selectedType.value : this.typesOptions[0].value , this.year).then(
          response => {
            this.partnerStats=response;
          } 
      ).finally(() => {
            this.isPartnerStatsLoading = false;
      })
    },

    refresh() {
      this.getPartnerStatsByMonth();
      this.getPartnerStats();
    },

    getCurrentMonthAndYear(){
        var dt = new Date();
        this.currentMonth=dt.getMonth();
        this.currentYear  = dt.getFullYear();
        this.year=this.currentYear;

          this.isAdmin= this.role == 1;
          this.hasReportingAccess= this.role == 1;
          this.hasCustomersHistoryAcess= this.role == 1;
          this.hasSynchronisationAccess= this.role == 1;
        
          this.isAdmin= this.role == 1;
          this.hasReportingAccess=true;
          this.hasCustomersHistoryAcess=true;
          this.hasSynchronisationAccess=true;
    },


  }
};
</script>
<style>

  .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>
  <Layout>


<div class="row pt-5 pb-2 justify-content-center align-items-end mb-3 mb-md-0">
    <div class="text-left">
        <span class="text-primary font-size-14 font-weight-bold">Veuillez sélectionner le type de rapport que vous souhaitez avoir</span>
        <div style="max-width: 550px; margin-left: auto; margin-right: auto;">
            <v-select class="style-vselect-big pt-2 font-weight-bold w-100" style="font-size:1.2em;" :options="typesOptions" label="text" v-model="selectedType">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
            </v-select>
        </div>
    </div>
    <div class="text-center ml-0 ml-sm-3 mt-sm-0 mt-3">
        <!-- Removed inline width. Apply max-width to the input-group if needed. -->
        <div class="input-group input-group-sm mx-auto" style="max-width: 150px; height: 37px;">
            <select class="custom-select custom-select-sm h-100 font-size-12" v-model="year">
                <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
            </select>
            <div class="input-group-append font-size-14">
                <label class="input-group-text">{{$t('years.label')}}</label>
            </div>
        </div>
    </div>
</div>

  <div v-if="partnerStatsByMonth || partnerStats || isPartnerStatsByMonthLoading || isPartnerStatsLoading" class="row p-sm-4">
    <div class="col-12">
      <div v-if="role==1  && firstDay && lastDay">
        <div class="row mt-4">
          <div class="col-12 col-md-12">
            <div class="card  "> 
              <div class="card-body ">
              
                <div v-if="isPartnerStatsByMonthLoading" class="text-center my-5">
                  <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>

                <PartnerChanelChart    v-else-if="this.partnerStatsByMonth"
                :data="partnerStatsByMonth.totalQuantity"  
              :categories="partnerStatsByMonth.month"
              name="Volume ventes mensuelles"  title='Volume des Ventes Mensuelles'
                  :labels="['Volume des ventes mensuelles'  ]"
                  />
              </div>
            </div>
          </div>
        </div>

        <div v-if="partnerStats || isPartnerStatsLoading" class="row mt-4">
          <div class="col-12 col-md-12">
            <div class="card  "> 
              <div class="card-body p-5" >

              <div class="d-flex justify-content-between align-items-center">

                <div class="font-size-20 font-weight-bold">
                  Etat des Stocks et Ventes par Article
                </div>

                <div v-if="isPartnerStatsExportEnabled" class="d-flex">
                  <button class="btn btn-success btn-sm mr-2" @click="exportXLS">
                    <i class="fa fa-file-excel"></i> XLS
                  </button>

                  <button class="btn btn-danger btn-sm" @click="exportPDF">
                    <i class="fa fa-file-pdf"></i> PDF
                  </button>
                </div>

              </div>

          <div v-if="isPartnerStatsLoading" class="text-center my-5">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>

          <div v-else class="table-responsive mb-0 mt-5" style="max-height:60em;min-height:60em ;overflow-y: auto;">
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="partnerStatsItems"
            :fields="partnerItemFields"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:cell(stock)="{value}">
              <i v-if="value==0 " class="fas fa-times-circle text-secondary align-middle font-size-12" />
              <div v-else class="text-primary font-weight-bold"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(january)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(february)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(march)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(april)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(may)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(june)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(july)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(august)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>

            <template v-slot:cell(september)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>
            <template v-slot:cell(october)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>
            <template v-slot:cell(november)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>
            <template v-slot:cell(december)="{value}">
              <div :class="value > 0 ? 'text-success font-weight-bold' :  value < 0 ? 'text-danger font-weight-bold' : ''"> {{ value ?  value : '-' }}</div>
            </template>


            </b-table>
        </div>

              </div>
            </div>
          </div>
</div>





     



      </div>


    </div>
  </div>

  </Layout>
</template>

<style scoped>

.custom-year-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: white;
  border-color: #ddd;
  border-right: 0;
}

::v-deep thead {
  position: sticky;
  top: 0;
  background-color: white; /* Optional: Set the background color of the header */
  z-index: 1;}
</style>














